<!-- eslint-disable -->
<template>
    <el-container>
        <el-row class="list-container">
            <el-col :span="24">
                <el-button @click="refreshData" type="primary" size="small" icon="iconfont icon-shuaxin shuaxin">刷新</el-button>
                <el-button type="primary" size="small" icon="iconfont icon-jia shuaxin" @click="dialogFormVisible = true" :disabled="!power.prize_add">新增</el-button>
                <!-- <el-button @click="delMultiple" type="danger" size="small" icon="iconfont icon-shanchu shuaxin">删除</el-button> -->
            </el-col>

            <!-- search start  -->
            <!-- <el-col :span="24" class="search-content">
                <div class="search-item" style="width: 130px;">
                    <el-select v-model="data.searchSelect" placeholder="请选择titleSelect" size="small">
                        <el-option
                            v-for="item in [{id: 1, name: 'test_select'}]"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div class="search-item">
                    <el-input v-model="data.searchText" size="small" placeholder="请输入textContent" clearable></el-input>
                </div>
                <div class="search-item">
                    <el-button size="small" icon="iconfont icon-fangdajing shuaxin" @click="search">搜索</el-button>
                </div>
            </el-col> -->
            <!-- search end  -->

            <el-col class="main-content">
                <el-table :data="dataList" border @selection-change="handleSelectionChange" v-loading="loading" style="width: 100%">
                    <!-- <el-table-column type="selection" width="55"></el-table-column> -->
                    <el-table-column prop="id" label="ID" width="80"></el-table-column>

                    <el-table-column prop="num_1" label="幸运号码1" width="120"></el-table-column>
                    <el-table-column prop="num_2" label="幸运号码2" width="120"></el-table-column>
                    <el-table-column prop="num_3" label="幸运号码3" width="120"></el-table-column>
                    <el-table-column prop="num_prize" label="中奖号码" width="120"></el-table-column>
                    <el-table-column prop="is_open" label="是否开奖" width="120">
                      <template slot-scope="scope">
                        <span v-if="scope.row.is_open == 2" style="color: #F56C6C;">已开奖</span>
                        <span v-else style="color: #909399;">待开奖</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="open_at" label="开奖时间" width="180"></el-table-column>
                    <el-table-column prop="open_periods" label="开奖期数" width="120"></el-table-column>
                    <el-table-column prop="prize_content" label="奖品" width="220">
                      <template slot-scope="scope">
                        <div>一等奖：{{scope.row.prize_content_1}}</div>
                        <div>二等奖：{{scope.row.prize_content_2}}</div>
                        <div>三等奖：{{scope.row.prize_content_3}}</div>
                        <div>四等奖：{{scope.row.prize_content_4}}</div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="created_at" label="创建时间" width="180"></el-table-column>
                    <el-table-column label="操作" min-width="180">
                        <template slot-scope="scope" v-if="scope.row.is_open != 2">
                            <el-button @click="editTmp(scope.row)" icon="iconfont icon-bianji shuaxin" type="primary" size="mini" plain :disabled="!power.prize_add">编辑</el-button>
                            <el-button @click="confirmNum(scope.row)" icon="iconfont iconqueren shuaxin" type="warning" size="mini" plain :disabled="!power.prize_confirm">确认号码</el-button>
                            <el-button @click="del(scope.row.id)" icon="iconfont icon-shanchu shuaxin" size="mini" type="danger" plain :disabled="!power.prize_del">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
            <el-col class="pagination">
                <el-pagination
                    @current-change="changePage"
                    @size-change="changePageSize"
                    background
                    :layout="pageLayout"
                    :page-sizes="pagePageSizes"
                    :page-size="pagePageSize"
                    :total="totalCount"
                    :current-page.sync="current_page"
                    :hide-on-single-page="false">
                </el-pagination>
            </el-col>
        </el-row>

        <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" :close-on-click-modal="false" @close="dialogClose" width="650px" center>
            <el-form :model="form" ref="form" class="dialog-form" @submit.native.prevent>
                <el-form-item label="幸运号码1 (100-999)"
                    :label-width="formLabelWidth"
                    prop="num_1"
                    :rules="[
                    { required: true, message: '请输入幸运号码1', trigger: 'blur' }
                    ]">
                    <el-input type="number" v-model="form.num_1" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="幸运号码2 (100-999)"
                    :label-width="formLabelWidth"
                    prop="num_2"
                    :rules="[
                    { required: true, message: '请输入幸运号码2', trigger: 'blur' }
                    ]">
                    <el-input type="number" v-model="form.num_2" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="幸运号码3 (100-999)"
                    :label-width="formLabelWidth"
                    prop="num_3"
                    :rules="[
                    { required: true, message: '请输入幸运号码3', trigger: 'blur' }
                    ]">
                    <el-input type="number" v-model="form.num_3" autocomplete="off"></el-input>
                </el-form-item>
                <!-- <el-form-item label="中奖号码"
                    :label-width="formLabelWidth"
                    prop="num_prize"
                    :rules="[
                    { required: false, message: '请输入中奖号码', trigger: 'blur' }
                    ]">
                    <el-input type="text" v-model="form.num_prize" autocomplete="off" readonly></el-input>
                </el-form-item> -->
                <el-form-item label="开奖期数"
                    :label-width="formLabelWidth"
                    prop="open_periods"
                    :rules="[
                    { required: true, message: '请输入开奖期数', trigger: 'blur' }
                    ]">
                    <el-input type="text" v-model="form.open_periods" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="一等奖奖品"
                    :label-width="formLabelWidth"
                    prop="prize_content_1"
                    :rules="[
                    { required: true, message: '请输入一等奖奖品', trigger: 'blur' }
                    ]">
                    <el-input type="text" v-model="form.prize_content_1" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="二等奖奖品"
                    :label-width="formLabelWidth"
                    prop="prize_content_2"
                    :rules="[
                    { required: true, message: '请输入二等奖奖品', trigger: 'blur' }
                    ]">
                    <el-input type="text" v-model="form.prize_content_2" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="三等奖奖品"
                    :label-width="formLabelWidth"
                    prop="prize_content_3"
                    :rules="[
                    { required: true, message: '请输入三等奖奖品', trigger: 'blur' }
                    ]">
                    <el-input type="text" v-model="form.prize_content_3" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="四等奖奖品"
                    :label-width="formLabelWidth"
                    prop="prize_content_4"
                    :rules="[
                    { required: true, message: '请输入四等奖奖品', trigger: 'blur' }
                    ]">
                    <el-input type="text" v-model="form.prize_content_4" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="addData('form')">确 定</el-button>
            </div>
        </el-dialog>
    </el-container>
</template>

<!-- eslint-disable -->
<script>
    import {PrizeIndex, PrizeAdd, PrizeDel, PrizeConfirm} from "@/utils/request.js"
    import {mapState} from "vuex"

    export default {
        data(){
            return {
                data: {
                    page: 1,
                    page_size: this.pagePageSize,
                    searchSelect: '',
                    searchText: '',
                },
                loading: false,
                dataList: [],
                totalCount: 0,
                current_page: 1,
                dialogFormVisible: false,
                loadingAdd: false,
                dialogTitle: "新增幸运号码",
                formLabelWidth: "180px",
                form: {
                    id: 0,
                    num_1: "",
                    num_2: "",
                    num_3: "",
                    num_prize: "",
                    open_periods: "",
                    prize_content_1: "",
                    prize_content_2: "",
                    prize_content_3: "",
                    prize_content_4: "",
                },
                multipleSelection: [],
            }
        },
        created() {
            this.getList()
        },
        computed: mapState(["power"]),
        methods: {
            search() {
                this.data.page = 1
                this.current_page = 1
                this.getList()
            },
            refreshData() {
                this.data.page = 1
                this.current_page = 1
                this.loading = true

                this.getList()
            },
            getList() {
                this.loading = true
                PrizeIndex(this.data).then((res) => {
                    if (res.code == 200) {
                        this.data.page++
                        this.dataList = res.data.data
                        this.totalCount = res.data.count
                    } else {
                        this.$message.error("数据获取失败!")
                    }
                    this.loading = false
                })
            },
            changePage(page) {
                this.data.page = page
                this.getList()
            },
            changePageSize(size) {
                this.data.page_size = size
                this.data.page = 1
                this.current_page = 1
                this.getList()
            },
            addData(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.loadingAdd = true
                        PrizeAdd(this.form).then((res) => {
                            if (res.code == 200) {
                                this.$message.success(res.msg);
                                this.dialogFormVisible = false
                                this.data.page--
                                this.getList()
                            } else {
                                this.$message.error(res.msg);
                            }
                            this.loadingAdd = false
                        })
                    }
                });
            },
            editTmp(data) {
                this.form = {
                    id: data.id,
                    num_1: data.num_1,
                    num_2: data.num_2,
                    num_3: data.num_3,
                    num_prize: data.num_prize,
                    open_periods: data.open_periods,
                    prize_content_1: data.prize_content_1,
                    prize_content_2: data.prize_content_2,
                    prize_content_3: data.prize_content_3,
                    prize_content_4: data.prize_content_4,
                }
                this.dialogTitle = this.form.id > 0 ? "编辑幸运号码" : "新增幸运号码"
                this.dialogFormVisible = true
            },
            dialogClose() {
                this.initForm()
            },
            initForm() {
                // 初始化，form数据
                this.form = {
                    id: 0,
                    num_1: "",
                    num_2: "",
                    num_3: "",
                    num_prize: "",
                    open_periods: "",
                    prize_content_1: "",
                    prize_content_2: "",
                    prize_content_3: "",
                    prize_content_4: "",
                }
                // 重置字段验证
                this.$refs["form"].resetFields();
                this.dialogTitle = "新增幸运号码"
            },
            handleSelectionChange(val) {
                this.multipleSelection = []
                if (val.length > 0) {
                    val.filter((item) => {
                        this.multipleSelection.push(item.id)
                    })
                }
            },
            delMultiple() {
                if (this.multipleSelection.length == 0) {
                    this.$message.error("请至少选择一项你要删除的项");
                    return
                }
                this.del(this.multipleSelection)
            },
            del(id) {
                this.$confirm("确定要执行删除操作吗?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "error"
                }).then(() => {
                    PrizeDel({id: id}).then((res) => {
                        if (res.code == 200) {
                            this.data.page--
                            this.getList()
                            this.$message.success(res.msg);
                        } else {
                            this.$message.error(res.msg);
                        }
                    })
                }).catch(() => {
                    // 取消操作
                });
            },
            confirmNum(row) {
                this.$confirm("确认号码就会立即开奖，此操作不可逆，确定要执行吗？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    PrizeConfirm({id: row.id}).then((res) => {
                        if (res.code == 200) {
                            this.data.page--
                            this.getList()
                            this.$message.success(res.msg);
                        } else {
                            this.$message.error(res.msg);
                        }
                    })
                }).catch(() => {
                    // 取消操作
                });
            },
        }
    }
</script>

<style>
</style>
